import { Rate } from 'antd';
import { Question } from '../../types/survey.types';

interface RatingQuestionProps {
  question: Question;
  value?: number;
  onChange: (value: number) => void;
}

const getBadgeColor = (score: number, min: number, max: number): string => {
  const normalized = (score - min) / (max - min);
  if (normalized <= 0.3) return '#ef4444';
  if (normalized <= 0.6) return '#f59e0b';
  if (normalized <= 0.8) return '#3b82f6';
  return '#22c55e';
};

const RatingQuestion = ({ question, value, onChange }: RatingQuestionProps) => {
  const options = question.options as { min?: number; max?: number };
  const min = options?.min || 1;
  const max = options?.max || 5;
  const count = max - min + 1;

  const currentValue = (value || 0) - min + 1;
  const badgeColor = value !== undefined ? getBadgeColor(value, min, max) : undefined;

  return (
    <div className="space-y-5">
      <div className="flex flex-col items-center gap-4">
        <Rate
          count={count}
          value={currentValue}
          onChange={(val) => onChange(val + min - 1)}
          style={{ fontSize: 32, color: '#fadb14' }}
          character={({ index = 0 }) => (index) + 1}
        />
        {value !== undefined ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 56,
                height: 56,
                borderRadius: '50%',
                backgroundColor: badgeColor,
                color: 'white',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                flexShrink: 0,
              }}
            >
              {value}
            </div>
            <span style={{ color: '#6b7280', fontSize: '0.875rem' }}>de {max} pontos</span>
          </div>
        ) : (
          <p className="text-sm text-gray-400">Toque em um número para avaliar</p>
        )}
      </div>
    </div>
  );
};

export default RatingQuestion;
